import * as React from 'react';
import { AuthServerSidePropsContext, TBasePageProps, TGetServerSideProps } from 'types';
import withSession from '@/src/auth/withSession';
import Head from 'next/head';
import { SignupModal } from '@/src/SignupModal';

type Props = TBasePageProps;
const HeadTags = React.memo(() => {
  const getTitleAndDescription = () => {
    return {
      tabTitle: 'Awning | Sign up',
      meta: {
        title: `Sign up for an account`,
        description: `Get unlimited access to all our properties for free.`,
      },
    };
  };

  const {
    tabTitle,
    meta: { title, description },
  } = getTitleAndDescription();

  return (
    <Head>
      <title>{tabTitle ?? title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />

      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@tryawning" />
      <meta name="twitter:creator" content="@tryawning" />
      <meta
        name="twitter:image"
        content={`${process.env.NEXT_PUBLIC_BASE_PATH}/twitter-preview.jpg`}
      />

      <meta property="og:title" content={title} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="628" />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={description} />
      <meta
        property="og:image"
        content={`${process.env.NEXT_PUBLIC_BASE_PATH}/facebook-preview.jpg`}
      />
    </Head>
  );
});

const SignupContainer: React.FC<React.PropsWithChildren<Props>> = () => {
  return (
    <>
      <HeadTags />
      <SignupModal
        isOpen={true}
        config={{
          allowClose: false,
          fullPage: true,
        }}
      />
    </>
  );
};

export const getServerSideProps = withSession(
  async ({ req }: AuthServerSidePropsContext): TGetServerSideProps<Props> => {
    const user = req.session.user;

    if (user !== undefined) {
      return {
        redirect: {
          destination: '/top-airbnb-markets',
          permanent: false,
        },
      };
    }

    return {
      props: {},
    };
  }
);

export default SignupContainer;
